import { Injectable } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { FormSubmWarningModalComponent } from './form-subm-warning-modal.component';

@Injectable()
export class FormSubmWarningModalService {
  constructor(private modalService: NgbModal) {}

  public openWarningModal(
    title: string = 'Warning',
    messages: string[] = [],
    btnOkText: string = 'Warning',
    btnCancelText: string = 'Edit Application',
    dialogSize: 'sm' | 'lg' = 'lg'
  ): Promise<boolean> {
    const modalRef = this.modalService.open(FormSubmWarningModalComponent, {
      size: 'lg'
    });
    modalRef.componentInstance.title = title;
    modalRef.componentInstance.messages = messages;
    modalRef.componentInstance.btnOkText = btnOkText;
    modalRef.componentInstance.btnCancelText = btnCancelText;

    return modalRef.result;
  }
}
